export DEMO_SONGS := [{
  title: "Dubsgrace"
  author: "diamondblaze413"
  slug: "api-4IuXACKoqtSke9jTAThC5I_eWc4me53ze-1cri-L8kE"
}, {
  title: "Orinoco Flow"
  author: "Enya"
  slug: "api-xeSsrUhuXkiWKC2_4pwoaCc80rK1hRX7uLeRM8dOs7g"
}, {
  title: "MeGaLoVania"
  author: "Toby Fox (arranged by Jackattack413)"
  slug: "50c687fa90400971abb010e741aa78c4"
}, {
  title: "Mushroom Forest"
  author: "Junko Tamiya (Little Nemo: The Dream Master NES) (arranged by Daniel X Moore)"
  slug: "api-KyDf0uvvBi4xOv-_Ze8-cwrEqHC_Qy_fNqgg984FbN8"
}, {
  title: "Wind Forest"
  author: "Joe Hisaishi (arranged by A. E. Moore)"
  slug: "api-4G6CcZfyxeWyEjtnBNq_3_D3rWC1AYVYpqoxBpbit08"
}, {
  title: "600 AD"
  author: "(arranged by LachrymatoryAgent)"
  slug: "13ff6ed6dd7c14fdaf63"
}]

export default DEMO_SONGS
